import { useSelector } from 'react-redux'
import { RootState } from '../redux'

export default function useValveAlertRules() {
  return useSelector((state: RootState) => state.valve.alertRules)
}
